import { FC } from 'react';
import { Box, ButtonBase } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import type { SortOrderEnum } from '@/services/noteGoApi/noteGoApiSchemas';
import type { NoteSortField } from '@/constants/noteListColumns';

interface NoteListHeaderProps {
  sortBy: NoteSortField;
  sortOrder: SortOrderEnum;
  onSortChange: (field: NoteSortField) => void;
  showThumbnails: boolean;
}

const SORT_FIELDS: NoteSortField[] = ['created_at', 'title', 'is_favorite', 'duration'];

const SORT_LABELS: Record<NoteSortField, string> = {
  title: 'Title',
  duration: 'Duration',
  created_at: 'Date',
  is_favorite: 'Favorites',
};

const NoteListHeader: FC<NoteListHeaderProps> = ({ sortBy, sortOrder, onSortChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        flexWrap: 'wrap',
      }}
    >
      {SORT_FIELDS.map((field) => {
        const isActive = sortBy === field;

        return (
          <ButtonBase
            key={field}
            onClick={() => onSortChange(field)}
            disableRipple
            aria-label={`Sort by ${SORT_LABELS[field]}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              px: 1.5,
              height: 30,
              borderRadius: '100px',
              fontSize: 12,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? '#fff' : 'text.secondary',
              backgroundColor: isActive ? 'primary.main' : 'transparent',
              border: '1px solid',
              borderColor: isActive ? 'primary.main' : 'divider',
              transition: 'all 0.2s ease',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: isActive ? 'primary.dark' : 'action.hover',
                borderColor: isActive ? 'primary.dark' : 'text.disabled',
              },
            }}
          >
            <span>{SORT_LABELS[field]}</span>
            {isActive &&
              (sortOrder === 'asc' ? (
                <ArrowUpwardIcon sx={{ fontSize: 13, ml: 0.25 }} />
              ) : (
                <ArrowDownwardIcon sx={{ fontSize: 13, ml: 0.25 }} />
              ))}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default NoteListHeader;
